
































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// import { Pagination } from 'element-ui';
@Component({
  name: 'lb-pagination',
  // components: {
  //   'el-pagination': Pagination
  // }
})


export default class extends Vue {
  @Prop({ default: 10 }) private pageSize!: number;
  @Prop({ type: Boolean, default: false }) private small!: boolean;
  @Prop() private total!: number;
  @Prop() private pageCount!: number;
  @Prop({
    validator(value) {
      return (value | 0) === value && value > 4 && value < 22 && (value % 2) === 1;
    },
    default: 7,
  }) private pagerCount!: number;
  @Prop({ default: 1 }) private currentPage!: number;
  @Prop({ default: 'prev, pager, next, total' }) private layout!: string;
  @Prop({ default: () => [10, 20, 30, 40, 50, 100] }) private pageSizes!: number[];
  @Prop() private prevText!: string;
  @Prop() private nextText!: string;
  @Prop({ type: Boolean, default: true }) private background!: boolean;
  @Prop({ type: Boolean, default: false }) private disabled!: boolean;


  // @Watch('currentPage')
  // getLocalPage(newVal:number, oldVal:number) {
  //   debugger
  //   this.currentPage=newVal;
  //   console.log("newVal", newVal, "oldVal", oldVal)
  // }
  // private currentPage = this.currentPage;

  private handleSizeChange(num: number) {
    this.$emit('size-change', num);
  }
  private handleCurrentChange(page: number) {
    this.$emit('current-change', page);
  }
  private handlePrevClick() {
    if (this.currentPage > 1) {
      this.currentPage = this.currentPage - 1;
      this.$emit('prev-click', this.currentPage);
      this.$emit('current-change', this.currentPage);
    }
  }

  private setCurrentPage(page: number) {
    this.currentPage = page;
  }

  private handleNextClick() {
    if (this.currentPage < this.total / this.pageSize) {
      this.currentPage = this.currentPage + 1;
      this.$emit('next-click', this.currentPage);
      this.$emit('current-change', this.currentPage);
    }
  }
}
